/** 누른 때 사진 svg 의 화면 위치(px). */
export interface SvgAnchor {
  readonly left: number;
  readonly top: number;
}

export const svgAnchorOf = (svg: SVGSVGElement): SvgAnchor => {
  const rect = svg.getBoundingClientRect();
  return { left: rect.left, top: rect.top };
};

/**
 * 끄는 포인터의 화면 좌표를 누른 때의 사진 위치 기준으로 돌려준다. 누르며 고른 영역 때문에 사이드바 높이가 바뀌어
 * 붙박이(sticky) 사진 칸이 화면에서 움직이면, 가만히 있는 포인터가 사진 위에서는 움직인 것처럼 보여 끈 거리가 틀어진다 —
 * 사진이 움직인 만큼 포인터 좌표도 옮겨 화면에서 끈 거리만 남긴다.
 */
export const anchoredClient = (
  svg: SVGSVGElement,
  anchor: SvgAnchor,
  client: { readonly x: number; readonly y: number },
): { x: number; y: number } => {
  const now = svgAnchorOf(svg);
  return { x: client.x + now.left - anchor.left, y: client.y + now.top - anchor.top };
};
